const DEFAULT_IOS_APP_URL = "https://apps.apple.com/kz/app/agrostream-lite/id6757006228"
const DEFAULT_ANDROID_APP_URL = "https://play.google.com/store/apps/details?id=com.anonymous.agrostreamlitemobile"

function readRuntimeConfig(key) {
  const runtimeConfig = window.__CONFIG__ || {}
  const value = runtimeConfig[key]

  if (!value || value === `\${${key}}`) {
    return ""
  }

  return value
}

export function detectMobilePlatform({
  userAgent = navigator.userAgent,
  platform = navigator.platform,
  maxTouchPoints = navigator.maxTouchPoints,
} = {}) {
  if (/android/i.test(userAgent)) {
    return "android"
  }

  const isIOSUserAgent = /iPad|iPhone|iPod/i.test(userAgent)
  const isIPadWithDesktopUserAgent = platform === "MacIntel" && maxTouchPoints > 1

  if (isIOSUserAgent || isIPadWithDesktopUserAgent) {
    return "ios"
  }

  return null
}

export function getMobileAppConfig() {
  return {
    deepLink: readRuntimeConfig("MOBILE_APP_DEEP_LINK"),
    iosStoreUrl: readRuntimeConfig("IOS_APP_URL") || DEFAULT_IOS_APP_URL,
    androidStoreUrl: readRuntimeConfig("ANDROID_APP_URL") || DEFAULT_ANDROID_APP_URL,
  }
}
